var map = {
	"./img/banner1.jpg": 8477,
	"./img/banner1.webp": 9038,
	"./img/banner2.jpg": 8578,
	"./img/banner3.jpg": 959,
	"./img/category1.jpg": 6011,
	"./img/category2.jpg": 1356,
	"./img/category3.jpg": 1881,
	"./img/category4.jpg": 1514,
	"./img/company.jpg": 2007,
	"./img/cutting-header.png": 5986,
	"./img/cutting/cutting1.png": 4738,
	"./img/cutting/cutting2.png": 2921,
	"./img/cutting/cutting3.png": 8720,
	"./img/cutting/cutting4.png": 6751,
	"./img/cutting/materials1.png": 4544,
	"./img/cutting/materials2.png": 6523,
	"./img/cutting/materials3.png": 1698,
	"./img/cutting/materials4.png": 6557,
	"./img/cutting/materials5.png": 2660,
	"./img/cutting/materials6.png": 9519,
	"./img/cutting/service1.jpg": 9717,
	"./img/cutting/service2.jpg": 7642,
	"./img/cutting/service3.jpg": 5383,
	"./img/cutting/service4.jpg": 7484,
	"./img/default.png": 6617,
	"./img/line.jpg": 2826,
	"./img/logo.svg": 7503,
	"./img/no-image.jpg": 6301,
	"./img/scraps/1-01.jpg": 6620,
	"./img/scraps/1-02.jpg": 9419,
	"./img/scraps/1-03.jpg": 8286,
	"./img/scraps/1-04.jpg": 9109,
	"./img/scraps/1-05.jpg": 6744,
	"./img/scraps/1-06.jpg": 967,
	"./img/scraps/1-07.jpg": 6506,
	"./img/scraps/1-08.jpg": 7649,
	"./img/scraps/1-09.jpg": 9604,
	"./img/scraps/2-01.jpg": 3053,
	"./img/scraps/2-02.jpg": 5250,
	"./img/scraps/2-03.jpg": 5279,
	"./img/scraps/2-04.jpg": 8900,
	"./img/scraps/3-01.jpg": 38,
	"./img/scraps/3-02.jpg": 7793,
	"./img/scraps/3-03.jpg": 3460,
	"./img/scraps/3-04.jpg": 4895,
	"./img/scraps/3-05.jpg": 3186,
	"./img/scraps/3-06.jpg": 9117,
	"./img/scraps/3-07.jpg": 6896,
	"./img/scraps/3-08.jpg": 8507,
	"./img/scraps/3-09.jpg": 462,
	"./img/scraps/3-10.jpg": 7732,
	"./img/scraps/4-01.jpg": 1447,
	"./img/scraps/4-02.jpg": 2776,
	"./img/scraps/4-03.jpg": 6741,
	"./img/scraps/4-04.jpg": 7502,
	"./img/scraps/5-01.jpg": 4160,
	"./img/scraps/5-02.jpg": 7151,
	"./img/scraps/5-03.jpg": 770,
	"./img/scraps/5-04.jpg": 2465,
	"./img/scraps/5-05.jpg": 4420,
	"./img/scraps/5-06.jpg": 4467,
	"./img/scraps/5-07.jpg": 2854,
	"./img/scraps/5-08.jpg": 9317,
	"./img/scraps/5-09.jpg": 5352,
	"./img/scraps/6-01.jpg": 897,
	"./img/scraps/6-02.jpg": 9478,
	"./img/scraps/6-03.jpg": 1651,
	"./img/scraps/6-04.jpg": 0,
	"./img/scraps/6-05.jpg": 925,
	"./img/scraps/6-06.jpg": 1666,
	"./img/scraps/7-01.jpg": 8058,
	"./img/scraps/7-02.jpg": 661,
	"./img/scraps/7-03.jpg": 8296,
	"./img/scraps/7-04.jpg": 971,
	"./img/scraps/8-01.jpg": 5451,
	"./img/scraps/8-02.jpg": 3932,
	"./img/scraps/8-03.jpg": 8281,
	"./img/scraps/8-04.jpg": 2538,
	"./img/scraps/8-05.jpg": 8343,
	"./img/scraps/8-06.jpg": 1848,
	"./img/scraps/9-01.jpg": 8244,
	"./img/scraps/9-02.jpg": 7955,
	"./img/scraps/9-03.jpg": 4822,
	"./img/scraps/9-04.jpg": 3901,
	"./img/scraps/9-05.jpg": 1680,
	"./img/scraps/9-06.jpg": 9679,
	"./img/scraps/9-07.jpg": 7970,
	"./img/scraps/9-08.jpg": 2361,
	"./img/scraps/9-09.jpg": 1308,
	"./img/scraps/9-10.jpg": 3210,
	"./img/scraps/9-11.jpg": 4375,
	"./img/scraps/9-12.jpg": 3448,
	"./img/scraps/9-13.jpg": 1061,
	"./img/scraps/9-14.jpg": 3726,
	"./img/scraps/9-15.jpg": 5035,
	"./img/scraps/9-16.jpg": 8060,
	"./img/scraps/9-17.jpg": 9673,
	"./img/scraps/default.jpg": 5548,
	"./img/scraps/type1.jpg": 346,
	"./img/scraps/type2.jpg": 4549,
	"./img/scraps/type3.jpg": 584,
	"./img/scraps/type4.jpg": 2171,
	"./img/scraps/type5.jpg": 862,
	"./img/scraps/type6.jpg": 6809,
	"./img/scraps/type7.jpg": 5196,
	"./img/scraps/type8.jpg": 6031,
	"./img/scraps/type9.jpg": 6002,
	"./img/test/1234.webp": 4062,
	"./img/test/bak/category1.jpg": 6063,
	"./img/test/bak/category2.jpg": 8064,
	"./img/test/bak/used-items-header.jpg": 3008,
	"./img/test/used-items-header.jpg": 3227,
	"./img/tidying-header.png": 6826,
	"./img/used-items-header.jpg": 4084,
	"./img/visit-header.jpg": 8037,
	"./img/visit-header.png": 3573,
	"./img/visit.png": 2879,
	"./img/wechat.jpg": 6058,
	"./json/goods": 3774,
	"./json/goods.json": 3774,
	"./json/scrap_items": 6062,
	"./json/scrap_items.json": 6062,
	"./tailwind.css": 5357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;